(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["about-this-item"] && !Shopify.designMode) return;
  try {
    /*
   * No Liquid used here — panel is found via the button's own
   * aria-controls attribute which is already rendered in the HTML.
   * Uses event delegation on document so it works on:
   *   - Page load
   *   - Theme Customizer preview refresh (shopify:block:load / section:load)
   */
  (function () {
    function bindAccordions(root) {
      (root || document).querySelectorAll('.ati-trigger').forEach(function (btn) {
        if (btn.dataset.atiBound) return;
        btn.dataset.atiBound = '1';

        btn.addEventListener('click', function () {
          var isExpanded = btn.getAttribute('aria-expanded') === 'true';
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          if (!panel) return;

          btn.setAttribute('aria-expanded', String(!isExpanded));
          panel.setAttribute('aria-hidden', String(isExpanded));
        });
      });
    }

    // Initial bind
    bindAccordions(document);

    // Re-bind after Customizer section/block reloads
    document.addEventListener('shopify:block:load',   function (e) { bindAccordions(e.target); });
    document.addEventListener('shopify:section:load', function (e) { bindAccordions(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (function () {
    function bindOrderNow(root) {
      (root || document).querySelectorAll('.btn-order-now').forEach(function (btn) {
        if (btn.dataset.bound) return;
        btn.dataset.bound = '1';
        btn.addEventListener('click', async function () {
          var form = btn.closest('form');
          var variantId = form ? form.querySelector('input[name="id"]')?.value : btn.dataset.variantId;
          var quantity = form ? (parseInt(form.querySelector('input[name="quantity"]')?.value, 10) || 1) : 1;
          if (!variantId) return;
          btn.disabled = true;
          btn.textContent = '…';
          try {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity })
            });
            window.location.href = '/checkout';
          } catch (e) {
            btn.disabled = false;
            btn.textContent = btn.getAttribute('aria-label') || 'Order Now';
          }
        });
      });
    }
    bindOrderNow(document);
    document.addEventListener('shopify:section:load', function (e) { bindOrderNow(e.target); });
    document.addEventListener('shopify:block:load', function (e) { bindOrderNow(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

})();
